import { Box, LinearProgress, useTheme } from "@mui/material";

function InlineLoader({ width = "100%" }) {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width={"100%"}
    >
      <LinearProgress
        variant="indeterminate"
        color="primary"
        sx={{
          width: typeof width === "number" ? `${width}px` : width,
          height: 4,
          borderRadius: 999,
          backgroundColor: theme.palette.grey[200],
          "& .MuiLinearProgress-bar": {
            borderRadius: 999,
            backgroundColor: theme.palette.primary.main,
          },
        }}
      />
    </Box>
  );
}

export default InlineLoader;
